/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import Rails from "@rails/ujs";
Rails.start();

import "bootstrap/dist/js/bootstrap";

import "javascripts/asset-image";
import "javascripts/autosize";
import "javascripts/clipboard-copy";
import "javascripts/shared";
import "javascripts/twitter_widget";

import "javascripts/webpage/aggregated_hotels-show";
import "javascripts/webpage/aos";
import "javascripts/webpage/bulk-clips";
import "javascripts/webpage/clips";
import "javascripts/webpage/common";
import "javascripts/webpage/dropdown-list";
import "javascripts/webpage/grecaptcha";
import "javascripts/webpage/inquiries";
import "javascripts/webpage/instagram_no_image";
import "javascripts/webpage/lazyload";
import "javascripts/webpage/map-image";
import "javascripts/webpage/modal-lazyload";
import "javascripts/webpage/onclick";
import "javascripts/webpage/presses";
import "javascripts/webpage/rich_content";
import "javascripts/webpage/section-navigation";
import "javascripts/webpage/sentry";
import "javascripts/webpage/smooth-scroll";
import "javascripts/webpage/specials";
import "javascripts/webpage/spot-map";
import "javascripts/webpage/surveys";
import "javascripts/webpage/swipe-for-windows";
import "javascripts/webpage/tab";
import "javascripts/webpage/trip-lists";
import "javascripts/webpage/users";

import "javascripts/webpage/pc/aggregated_hotels-show";
import "javascripts/webpage/pc/instagram-mag";
import "javascripts/webpage/pc/spottable";
